import axios from 'axios/index';
import common from './common.js';
import Cookies from 'js-cookie';

const api = {
    common,
    // ip: '192.168.1.222:9206', // 本地服
    // backip: '192.168.1.222:12125' // 后台
    ip: '39.105.49.146:9206', // 广告主协会正式服
    backip: '39.105.49.146:9100' // 广告主协会后台
};

// let posServer = 'https://' + api.ip + '/api/'; // 正式服
let posServer = 'http://' + api.ip + '/'; // 本地
let backposServer = 'http://' + api.backip + '/api/'; // 后台

api.imgIP = posServer;

api.filesParams = {
    module: 'unpaidbills',
    category: '平台', // 上传的文件目录
    key: 'files'
};

api.handleReply = function (data, vm, callback, errCallback) {
    if (data.status === 200) {
        if (data.data.error !== '') {
            window.console.log('错误数据', data);
            vm.$Spin.hide();
            vm.$Message.error(data.data.error);
            errCallback && errCallback(data.data);
        } else {
            callback && callback(data.data);
        }
    } else if (data.status === 404) {
        vm.$router.push('404');
    } else if (data.status === 403) {
        vm.$router.push('403');
    } else {
        vm.$router.push('503');
    }
};

api.login = function (params, vm, callback, errCallback) {
    axios.post(posServer + 'login', params).then(data => {
        this.handleReply(data, vm, callback, errCallback);
    });
};

api.resetpwd = function (params, vm, callback, errCallback) {
    axios.post(posServer + 'resetpwd', params).then(data => {
        this.handleReply(data, vm, callback, errCallback);
    });
};

api.hasLogin = function (params, vm, callback, errCallback) {
    axios.post(posServer + 'haslogin/' + Cookies.get('icsf-ms-user') + '/web/' + Cookies.get('icsf-ms-token'), params).then(data => {
        this.handleReply(data, vm, callback, errCallback);
    });
};

api.save = function (params, vm, callback, errCallback) {
    axios.post(posServer + 'save/' + Cookies.get('icsf-ms-user') + '/web/' + Cookies.get('icsf-ms-token'), params).then(data => {
        this.handleReply(data, vm, callback, errCallback);
    });
};

api.saveM = function (params, vm, callback, errCallback) {
    axios.post(posServer + 'savem/' + Cookies.get('icsf-ms-user') + '/web/' + Cookies.get('icsf-ms-token'), params).then(data => {
        this.handleReply(data, vm, callback, errCallback);
    });
};

api.get = function (params, vm, callback, errCallback) {
    let vars = {
        params: {}
    };
    for (let key in params) {
        if (key === 'module' || key === 'key') {
            vars[key] = params[key]
        } else {
            vars.params[key] = params[key];
        }
    }
    axios.post(posServer + 'query/' + Cookies.get('icsf-ms-user') + '/web/' + Cookies.get('icsf-ms-token'), vars).then(data => {
        this.handleReply(data, vm, callback, errCallback);
    });
};


api.sQuery = function (params, vm, callback, errCallback) {
    let vars = {
        params: {}
    };
    for (let key in params) {
        if (key === 'module' || key === 'key') {
            vars[key] = params[key]
        } else {
            vars.params[key] = params[key];
        }
    }
    axios.post(backposServer + 'squery/' + 'superman' + '/web', vars).then(data => {
        this.handleReply(data, vm, callback, errCallback);
    });
};

api.del = function (params, vm, callback, errCallback) {
    let vars = {
        params: {}
    };
    for (let key in params) {
        if (key === 'module' || key === 'key') {
            vars[key] = params[key]
        } else if (key === 'ids') {
            vars.params[key] = params[key].join(',');
        } else {
            vars.params[key] = params[key];
        }
    }
    axios.post(posServer + 'del/' + Cookies.get('icsf-ms-user') + '/web/' + Cookies.get('icsf-ms-token'), vars).then(data => {
        this.handleReply(data, vm, callback, errCallback);
    });
};

api.admin = function (params, vm, callback, errCallback) {
    axios.post(posServer + 'admin/' + Cookies.get('icsf-ms-user') + '/web/' + Cookies.get('icsf-ms-token'), params).then(data => {
        this.handleReply(data, vm, callback, errCallback);
    });
};

api.ext = function (params, vm, callback, errCallback) {
    axios.post(posServer + 'ext/' + Cookies.get('icsf-ms-user') + '/web/' + Cookies.get('icsf-ms-token'), params).then(data => {
        this.handleReply(data, vm, callback, errCallback);
    });
};

api.update = function (params, vm, callback, errCallback) {
    axios.post(posServer + 'update/' + Cookies.get('icsf-ms-user') + '/web/' + Cookies.get('icsf-ms-token'), params).then(data => {
        this.handleReply(data, vm, callback, errCallback);
    });
};

api.updateM = function (params, vm, callback, errCallback) {
    axios.post(posServer + 'updatem/' + Cookies.get('icsf-ms-user') + '/web/' + Cookies.get('icsf-ms-token'), params).then(data => {
        this.handleReply(data, vm, callback, errCallback);
    });
};

api.webget = function (params, vm, callback, errCallback) {
    axios.get(posServer + 'artsbysec/'+ params.params.sec + '/' + params.params.status +  '/' + 'ESC' + '/' + params.params.page + '/' + params.params.count).then(data => {
        this.handleReply(data, vm, callback, errCallback);
    });
};

api.webgetdetail = function (params, vm, callback, errCallback) {
    axios.get(posServer + 'details' + '/' + params.params.id).then(data => {
        this.handleReply(data, vm, callback, errCallback);
    });
};

// 上传附件的地址
api.upload = function () {
    return posServer + 'upload/' + Cookies.get('icsf-ms-user') + '/web/' + Cookies.get('icsf-ms-token') + '?module=' +
        api.filesParams.module + '&category=' + api.filesParams.category + '&key=' + api.filesParams.key;
};

// 下载
api.download = function (path) {
    path = path || '';
    return posServer + 'download/' + Cookies.get('icsf-ms-user') + '/web/' + '?module=' +
        api.filesParams.module + '&category=' + api.filesParams.category + '&path=' + path;
};

api.branchGet = function (params, vm, callback, errCallback) {
  axios.get(posServer + 'artsbybranch/'+ params.params.id +  '/' + 'DESC' + '/' + params.params.page + '/' + params.params.count).then(data => {
    this.handleReply(data, vm, callback, errCallback);
  });
};

export default api;



// WEBPACK FOOTER //
// ./src/model/api.js